/* @flow */

import * as types from 'src/shared/app/topic/new/action/appNewTopicActionTypes';
import * as userTypes from 'src/shared/domain/user/action/userActionTypes';

import { createReducer } from 'src/shared/core/util/reducerUtils';

const initialState = {
  isReady: false,
  canCreateGroupTopic: null,
  groupErrorMessage: '',
};

const _setReady = (state: Object) => ({
  ...state,
  isReady: true,
});

const _unsetReady = (state: Object) => ({
  ...state,
  isReady: false,
});

const _setCanCreateGroup = (state: Object, action: Object) => {
  const { can_create_topic: canCreateGroupTopic, reason } = action.result;

  return {
    ...state,
    canCreateGroupTopic,
    // FIXME: If reason is undefined, the value disappears from the state
    groupErrorMessage: reason || '',
  };
};

export default createReducer(initialState, {
  [types.SET_NEW_TOPIC_READY]: _setReady,
  [types.UNSET_NEW_TOPIC_READY]: _unsetReady,
  [userTypes.FETCH_USER_CAN_CREATE_GROUP_TOPIC_SUCCESS]: _setCanCreateGroup,
});
